export default __webpack_public_path__ + "static/media/partner_logo_finn.2e84f793.svg";